import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@material-ui/core';
import TeamForm from './TeamForm';
import {API} from 'aws-amplify';
import {toast} from 'react-toastify';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useBreadcrumbActions } from '../../providers/breadcrumbProvider';

const EditTeam = ({onReload}) => {
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [initialTeam, setInitialTeam] = useState();
  const [error, setError] = useState();
  const breadcrumbActions = useBreadcrumbActions();

  let { id } = useParams();

  useEffect(() => {
    let aborted = false;
    const load = async () => {
      try {
        const result = await API.get('mongo', `/teams/${id}`);
        if (!aborted) {
          setInitialTeam(result);
        }
      } catch (e) {
        if (e.response && e.response.status === 404) {
          setError("Team not found");
        } else {
          throw e;
        }
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    load();
    return () => aborted = true;
  }, [id]);

  const onSubmit = async (form) => {
    setSaving(true);
    try {
      await API.put('mongo', `/teams/${id}`, {body: form});
      toast.success('Successfully edited team.');
      if (onReload) {
        onReload();
      }
      breadcrumbActions.pop();
    } catch (e) {
      toast.error(e.toString());
    } finally {
      setSaving(false);
    }
  }

  return (
    <Box>
      <Typography variant="h4">
        Edit Team
      </Typography>
      {
        error
      }
      { // TODO: loading screen
        !loading && !error &&
        <TeamForm
          onSubmit={onSubmit}
          initialValue={initialTeam}
          disabled={saving}
        />
      }
    </Box>
  );
}

EditTeam.propTypes = {
  onReload: PropTypes.string.isRequired
}
export default EditTeam;
